import { render, staticRenderFns } from "./Hoverable.vue?vue&type=template&id=2f6a09f4&"
import script from "./Hoverable.vue?vue&type=script&lang=ts&"
export * from "./Hoverable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports